// Cookie banner — shown once, the choice is remembered.
import { $, t, toast } from "./dom.js";

export function initCookie() {
  const banner = $(".js-cookie");
  if (!banner) return;

  let saved = null;
  try {
    saved = localStorage.getItem("sd-cookies");
  } catch (e) {
    /* ignore */
  }
  if (!saved) setTimeout(() => banner.classList.add("is-shown"), 900);

  const choose = (value) => {
    try {
      localStorage.setItem("sd-cookies", value);
    } catch (e) {
      /* ignore */
    }
    banner.classList.remove("is-shown");
  };
  $(".js-cookie-accept", banner).addEventListener("click", () => {
    choose("all");
    toast(t("cookieThanks"));
  });
  $(".js-cookie-decline", banner).addEventListener("click", () => choose("essential"));
}
